import CitySEOHead from "@/components/feature/CitySEOHead";
import ColumbusHeroSection from "./components/HeroSection";
import ColumbusStickyNav from "./components/StickyNav";
import ColumbusProcessingTimeSection from "./components/ProcessingTimeSection";
import ColumbusServicesSection from "./components/ServicesSection";
import ColumbusLocalAreaSection from "./components/LocalAreaSection";
import ColumbusTestimonialsSection from "./components/TestimonialsSection";
import ColumbusAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ColumbusComparisonSection from "./components/ComparisonSection";
import ColumbusMistakesSection from "./components/MistakesSection";
import ColumbusHowItWorksSection from "./components/HowItWorksSection";
import ColumbusFAQSection, { faqs } from "./components/FAQSection";
import ColumbusHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ColumbusFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function ColumbusPage() {
  return (
    <>
      <CitySEOHead
        city="Columbus"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/columbus"
        title="Emergency & Expedited Passport Columbus GA | Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Columbus, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Fort Benning and west Georgia travelers. Get your emergency passport fast!"
        geoPlacename="Columbus, Georgia"
        geoPosition="32.4610;-84.9877"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Columbus passport, same day passport Columbus, fast passport Georgia, Fort Benning passport"
      />
      <div className="font-sans">
        <ColumbusHeroSection />
        <ColumbusStickyNav />
        <ColumbusProcessingTimeSection />
        <ColumbusServicesSection />
        <ColumbusLocalAreaSection />
        <ColumbusTestimonialsSection />
        <ColumbusAcceptanceFacilitiesSection />
        <ColumbusComparisonSection />
        <ColumbusMistakesSection />
        <ColumbusHowItWorksSection />
        <ColumbusFAQSection />
        <ColumbusHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/columbus" state="GA" />
        <ColumbusFinalCTA />
      </div>
    </>
  );
}